import React from "react";
import { BrainCircuitIcon, ClipboardCheckIcon, ListOrderedIcon, SearchIcon, TableIcon } from "lucide-react";
import { SectionHeading } from "../SectionHeading";
import { SectionCta } from "../SectionCta";
import { resources } from "../../data/volumes";
const icons = {
  checklist: ClipboardCheckIcon,
  diagram: BrainCircuitIcon,
  table: TableIcon,
  sequence: ListOrderedIcon,
  review: SearchIcon
};
export function ResourcesSection() {
  return <section className="w-full bg-surface px-5 py-16 sm:py-24" data-id="element-323" data-mp="1f5a11rja93f6">
      <div className="mx-auto max-w-4xl" data-id="element-324" data-mp="1j9rgxfmiuwko">
        <SectionHeading eyebrow="More Than Six Digital Books" title="You'll Also Receive Practical Educational Resources" subtitle="The collection includes reusable materials designed to make studying and reviewing clinical concepts easier." data-id="element-325" data-mp="1j6lphtqf7ils" />

        <ul className="mt-10 divide-y divide-navy-900/10 overflow-hidden rounded-3xl bg-white shadow-card" data-id="element-326" data-mp="vhaz966p56lw">
          {resources.map(r => {
          const Icon = icons[r.icon];
          return <li key={r.title} className="flex items-start gap-4 p-5 sm:p-6" data-id="element-327" data-mp="1ici77gprjka2">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-navy-900 text-gold" data-id="element-328" data-mp="1e9lsw279aabx">
                  <Icon className="h-6 w-6" aria-hidden="true" data-id="element-329" data-mp="19fqzg71umgzn" />
                </span>
                <div data-id="element-330" data-mp="14gwjrdz6h8jr">
                  <h3 className="text-lg font-extrabold text-ink" data-id="element-331" data-mp="zjwe3468q7t6">{r.title}</h3>
                  <p className="mt-1 text-[15px] leading-relaxed text-ink-muted" data-id="element-332" data-mp="zhtdjq7gowa7">{r.text}</p>
                </div>
              </li>;
        })}
        </ul>

        <p className="mt-8 text-center text-lg font-black text-ink" data-id="element-333" data-mp="qk0xgjtx1klr">Everything organized into one educational reference system.</p>

        <SectionCta label="Get All 6 Specialized Volumes" data-id="element-334" data-mp="lmhj7jx7x7tt" />
      </div>
    </section>;
}